import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Github, Linkedin, Mail } from "lucide-react";
import { personal, navLinks } from "../data/mock";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t hairline relative overflow-hidden">
      <div className="noise" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-mono text-[11px] text-muted-foreground mb-4">
              — GET IN TOUCH
            </div>
            <h3 className="display-xl text-4xl md:text-6xl leading-[0.95] mb-8">
              Let’s build something
              <br />
              <span className="italic font-light">resilient.</span>
            </h3>
            <Link
              to="/contact"
              className="btn-primary"
              data-cursor-hover
            >
              Start a conversation <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] text-muted-foreground mb-4">
              — NAVIGATE
            </div>
            <ul className="space-y-3">
              {navLinks.map((n) => (
                <li key={n.path}>
                  <Link
                    to={n.path}
                    className="link-grow text-sm text-muted-foreground hover:text-foreground"
                    data-cursor-hover
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] text-muted-foreground mb-4">
              — ELSEWHERE
            </div>
            <ul className="space-y-3">
              <li>
                <a
                  href={personal.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="link-grow text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2"
                  data-cursor-hover
                >
                  <Linkedin size={14} /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  href={personal.github}
                  target="_blank"
                  rel="noreferrer"
                  className="link-grow text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2"
                  data-cursor-hover
                >
                  <Github size={14} /> GitHub
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${personal.email}`}
                  className="link-grow text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2"
                  data-cursor-hover
                >
                  <Mail size={14} /> Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t hairline grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
          <div className="font-mono text-[11px] text-muted-foreground">
            © {year} — {personal.name.toUpperCase()}
          </div>
          <div className="font-mono text-[11px] text-muted-foreground md:text-center">
            {personal.location}
          </div>
          <div className="font-mono text-[11px] text-muted-foreground md:text-right">
            <span className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-foreground animate-pulse" />
              {personal.status}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
